import React from 'react';
import DataContext from '../components/DataContext';

export interface QueryState<T> {
    data: T;
    error: Error | undefined;
    loading: boolean;
    __initialized: boolean;
}

export default <T extends {} = any>(
    url: string,
    initialData: any = undefined
): [QueryState<T>, (url: string, nextState: any) => void] => {
    const context = React.useContext(DataContext);
    const initialState = { data: initialData, loading: true, error: undefined, __initialized: false };
    const state = context.state[url] || initialState;
    const setPartialState = (path, nextState) =>
        context.setState(path, (currentState = initialState) => ({
            ...currentState,
            ...nextState,
        }));

    if (!window.top.invalidate) {
        window.top.invalidate = url => {
            setPartialState(url, { __initialized: false });
        };
    }

    return [state, setPartialState];
};
